import { render, staticRenderFns } from "./LexinKeyboardLangUkr.vue?vue&type=template&id=53e77874&"
import script from "./LexinKeyboardLangUkr.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangUkr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports